import React, { ComponentPropsWithoutRef, ReactNode, forwardRef } from 'react';

import { Box, Flex, Group, Space, Text } from '@mantine/core';
import { InfoComponent } from 'components/InfoComponent';
import i18n from 'i18n';

export interface SelectItemProps extends ComponentPropsWithoutRef<'div'> {
  icon: ReactNode;
  label: string;
  value: string;
  labelComponent?: ReactNode;
  info?: string;
  disabled?: boolean;
  maw?: number | string;
}

export const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(
  ({ icon, label, info, labelComponent, disabled, maw, ...others }: SelectItemProps, ref) => (
    <Box ref={ref} {...others}>
      <Group position="apart">
        <Group>
          {icon}
          <Box>
            <Text truncate={maw !== undefined ? true : undefined} maw={maw}>
              {i18n.t(label)}
            </Text>
          </Box>
        </Group>
        <Flex direction="row" align="center">
          {labelComponent}
          <Space w={10} />
          {info && (
            <InfoComponent disabled={disabled} withinPortal width={250} position="right" contentTranslationKey={info} />
          )}
        </Flex>
      </Group>
    </Box>
  )
);

SelectItem.displayName = 'SelectItem';
